import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActiveMediaTranscoderJobsViewModel } from './active.view-model';
import { IMediaTranscoderJobsListViewModelApi } from '../transcoder-job.view-model.api';
import {
  ETranscodingJobPriority,
  ETranscodingJobStatus,
} from '../../../../domain/media-transcoder/transcoder-job';
import { IMediaTranscoderRepository } from '../../../../domain/media-transcoder/media-transcoder.repository';
import { ActiveTranscoderJobViewModel } from './active-transcoder-job-view.model';

@Component({
  selector: 'media-transcoder-jobs-active',
  templateUrl: './active.component.html',
  styleUrls: ['./active.component.scss'],
})
export class MediaTranscoderJobsActiveComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  vm: ActiveMediaTranscoderJobsViewModel;

  private readonly captureMouseDownHandler = (event: MouseEvent) =>
    this.onDocumentMouseDownCapture(event);

  constructor(
    private _mediaTranscoderRepository: IMediaTranscoderRepository,
    private _changeDetectorRef: ChangeDetectorRef,
    private _elementRef: ElementRef<HTMLElement>,
  ) {
    this.vm = new ActiveMediaTranscoderJobsViewModel(<
      IMediaTranscoderJobsListViewModelApi
    >{
      async getJobs(): Promise<ActiveTranscoderJobViewModel[]> {
        const allDestinations =
          await _mediaTranscoderRepository.getTenantTranscodingDestinations();
        const allDestinationsDictionary = Object.assign(
          {},
          ...allDestinations.map((s) => ({ [s.id]: s.name })),
        );

        const jobs = await _mediaTranscoderRepository.getJobs([
          ETranscodingJobStatus.Active,
        ]);

        return jobs.map(
          (job) =>
            new ActiveTranscoderJobViewModel(
              job.id,
              job.name,
              allDestinationsDictionary[job.destinationId],
              '',
              '',
              job.estimatedEndTime.format('YYYY-MM-DD HH:mm:ss'),
              '',
              ETranscodingJobStatus[job.status].toString(),
              ETranscodingJobPriority[job.priority].toString(),
              job.itemStatuses,
              job.transcodingProfileId,
            ),
        );
      },
      updateDOM() {
        _changeDetectorRef.detectChanges();
      },
    });
  }

  ngAfterViewInit(): void {
    document.addEventListener('mousedown', this.captureMouseDownHandler, true);
  }

  ngOnDestroy(): void {
    document.removeEventListener(
      'mousedown',
      this.captureMouseDownHandler,
      true,
    );
  }

  private onDocumentMouseDownCapture(event: MouseEvent): void {
    if (this.vm.isGroupedJobsCollapsed) {
      return;
    }

    const groupEl = this.findMediaGroupAtPoint(event.clientX, event.clientY);
    if (!groupEl) {
      return;
    }

    const baseName = groupEl.getAttribute('data-base-name');
    if (!baseName) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.vm.toggleNameFilterByBaseName(baseName);
  }

  private findMediaGroupAtPoint(x: number, y: number): HTMLElement | null {
    const groups =
      this._elementRef.nativeElement.querySelectorAll<HTMLElement>(
        '.media-group',
      );

    for (let i = 0; i < groups.length; i++) {
      const rect = groups[i].getBoundingClientRect();
      if (
        x >= rect.left &&
        x <= rect.right &&
        y >= rect.top &&
        y <= rect.bottom
      ) {
        return groups[i];
      }
    }

    return null;
  }

  async ngOnInit() {
    await this.vm.refreshJobs();
  }
}
